import accuracy from './accuracy.md?raw';
import cameraPlacement from './camera-placement.md?raw';
import equipment from './equipment.md?raw';
import faq from './faq.md?raw';
import gettingStarted from './getting-started.md?raw';
import planning from './planning.md?raw';
import privacyPolicy from './privacy-policy.md?raw';
import raceDay from './race-day.md?raw';
import raceSetup from './race-setup.md?raw';
import rehearsal from './rehearsal.md?raw';
import results from './results.md?raw';
import review from './review.md?raw';
import roster from './roster.md?raw';
import runnerNotice from './runner-notice.md?raw';
import startLine from './start-line.md?raw';
import terms from './terms.md?raw';
import troubleshooting from './troubleshooting.md?raw';
import volunteers from './volunteers.md?raw';

export interface Doc {
  slug: string;
  title: string;
  section: string;
  body: string;
}

/** The customer guide, in reading order. Each page is a Markdown file in this folder. */
export const DOCS: Doc[] = [
  { slug: 'getting-started', title: 'Getting started', section: 'Start here', body: gettingStarted },
  { slug: 'planning', title: 'Planning your timing', section: 'Start here', body: planning },
  { slug: 'equipment', title: 'Equipment', section: 'Start here', body: equipment },
  { slug: 'camera-placement', title: 'Camera placement', section: 'Setting up', body: cameraPlacement },
  { slug: 'start-line', title: 'The start line', section: 'Setting up', body: startLine },
  { slug: 'roster', title: 'Your roster', section: 'Setting up', body: roster },
  { slug: 'race-setup', title: 'Setting up a race', section: 'Setting up', body: raceSetup },
  { slug: 'volunteers', title: 'Camera volunteers', section: 'Setting up', body: volunteers },
  { slug: 'rehearsal', title: 'Rehearsal checklist', section: 'Setting up', body: rehearsal },
  { slug: 'race-day', title: 'Race day', section: 'On the day', body: raceDay },
  { slug: 'review', title: 'Reviewing crossings', section: 'After the race', body: review },
  { slug: 'results', title: 'Results', section: 'After the race', body: results },
  { slug: 'accuracy', title: 'Accuracy: what to expect', section: 'Reference', body: accuracy },
  { slug: 'troubleshooting', title: 'Troubleshooting', section: 'Reference', body: troubleshooting },
  { slug: 'faq', title: 'FAQ', section: 'Reference', body: faq },
  { slug: 'runner-notice', title: 'Telling runners they’re filmed', section: 'Privacy & terms', body: runnerNotice },
  { slug: 'privacy-policy', title: 'Privacy policy', section: 'Privacy & terms', body: privacyPolicy },
  { slug: 'terms', title: 'Terms of use', section: 'Privacy & terms', body: terms },
];
